export default __webpack_public_path__ + "0ed4f26a96423933b3f8e1dc247a3db5.png";